"use client";

import { useToastNotification } from "@/hooks/notifications/use-toast-noficication";
import type { Route } from "next";
import { usePathname } from "next/navigation";
import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { toast } from "sonner";

export function ToastProvider() {
    useToastNotification();
    useErrorNotificationFromUrlHash();

    return <></>;
}

function useErrorNotificationFromUrlHash() {
    const router = useRouter();
    const pathname = usePathname();

    useEffect(() => {
        const { hash } = window.location;

        // Check if the URL contains an error hash
        if (hash.startsWith("#error")) {
            // Extract the error message from the hash
            const errorMessage = hash.split("#error=")[1] ?? "An unknown error occurred";

            console.error(decodeURIComponent(errorMessage));
            // Display the notification using Sonner after a second
            setTimeout(() => {
                toast.error("Error", { description: decodeURIComponent(errorMessage) });
            }, 1000);

            // Remove the hash from the URL
            router.replace(pathname as Route);
        }
    }, [router, pathname]);
}
